import { seccionHeadingV2, pdfFz } from "./stylesPDFv2";

/**
 * Bloque de observaciones (notas). Devuelve {} si no hay texto, para poder
 * insertarlo siempre en el content sin condicional adicional.
 * Presentación sobria: encabezado de sección elegante + texto, sin caja.
 *
 * @param {string} texto
 * @returns nodo pdfMake
 */
export const PDFNotesV2 = (texto) => {
  if (!texto) return {};
  return {
    margin: [0, 2, 0, 2],
    stack: [
      seccionHeadingV2("Observaciones"),
      { text: texto, style: "textoChico", fontSize: pdfFz(5.5), margin: [0, 0, 0, 2] },
    ],
  };
};

export default PDFNotesV2;
